import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { logBoundaryError } from 'services/logger';
import Fallback from 'components/common/fallback/Fallback';
import { LoadingMainPanelSection } from 'components/common/suspense-fallbacks/LoadingMainPanelSection';
import BadgesSummary, { type Props } from './BadgesSummary';

export const BadgesSummaryWrapper = (props: Props) => (
  <ErrorBoundary FallbackComponent={Fallback} onError={logBoundaryError}>
    <Suspense fallback={<LoadingMainPanelSection hasHeader={true} />}>
      <BadgesSummary {...props} />
    </Suspense>
  </ErrorBoundary>
);
